import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { AuthProvider } from 'react-oidc-context';

import App from './App';
import reportWebVitals from './reportWebVitals';
/*
const oidcConfig = {
  authority: `https://acesso.poa.br/auth/realms/acessogov`,
  redirect_uri: `https://emdiacompoa.portoalegre.rs.gov.br/`,
  post_logout_redirect_uri: `https://emdiacompoa.portoalegre.rs.gov.br/`,
  client_id: `compliance`,
  onSigninCallback: () => { window.history.replaceState({}, document.title, window.location.pathname) },
  automaticSilentRenew: true,
};
*/
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
 // <AuthProvider {...oidcConfig}>
    <React.StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.StrictMode>
 // </AuthProvider>
);

reportWebVitals();
